<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
          <b-row>
            <b-col>
              <b-form-group label="Name" label-for="name">
                <b-form-input id="name"
                              type="text"
                              :state="validateState('name')"
                              aria-describedby="liveFeedbackname"
                              v-model.lazy.trim="$v.form.name.$model"
                              placeholder="Name"
                              autofocus>
                </b-form-input>
                <b-form-invalid-feedback id="liveFeedbackname">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Description" label-for="description">
                <b-form-input id="description"
                              type="text"
                              :state="validateState('description')"
                              aria-describedby="liveFeedbackdescription"
                              v-model.lazy.trim="$v.form.description.$model"
                              placeholder="Description" />
                <b-form-invalid-feedback id="liveFeedbackdescription">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="" label-for="isEnabled">
                <b-form-checkbox v-model="form.isEnabled"
                                 id="isEnabled"
                                 name="isEnabled"
                                 switch>
                  Enabled?
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
                Submit
              </b-button>
              <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
              <br />
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import { required,decimal,helpers } from 'vuelidate/lib/validators'
  const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
  const alpha_numeric = helpers.regex('alpha_space', /^[a-zA-Z0-9\s]*$/)
  const formShape = {
    name: '',
    description: 0.0,
    isEnabled: false
  }

  export default {
    name: 'ElectricLineEdit',
    props: {
      electricLine: Object
    },
    data() {
      return {
        form: Object.assign({}, formShape),
        submitted: false
      }
    },
    computed: {
      isValid() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      },
      isDirty() {
        return this.$v.form.$anyDirty
      }
    },
    validations: {
      form: {
        name: {
          required,
          alpha_space
        },
        description: {
          alpha_numeric
        },
      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name]
        return $dirty ? !$error : null
      },
      onSubmit() {
        if (this.validate()) {
          this.$nextTick(() => {
            this.submitted = true
            let params = {
              lineName: this.$v.form.name.$model,
              description: this.$v.form.description.$model,
              isEnabled: this.form.isEnabled,
              id: this.electricLine.id
            }

            this.$store
              .dispatch('electrical/updateElectricLine', params)
              .then(response => {
                if (response.data.success == false) {
                  this.showErrorMsg({
                    message: response.data.error
                  })
                } else {
                  this.showSuccessMsg({
                    message: 'Record updated successfully.'
                  });
                  this.$emit('success')
                }

              })
              .catch(error => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                } else if (error.response.status == 422) {
                  this.showErrorMsg({
                    message: error.response.data.message
                  })
                } else {
                  this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
                }
              })
          })
        }
      },
      onCancel() {
        this.$emit('cancel')
      },
      onReset() {
        this.form = formShape
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
      validate() {
        this.$v.$touch()
        return !this.$v.form.$anyError
      }
    },
    beforeMount() {

      this.form.name = this.electricLine.lineName
      this.form.description = this.electricLine.description
      this.form.isEnabled = this.electricLine.isEnabled == 0 ? false : true
    },
    created() {}
  }

</script>
